import { FlatRateUnit } from '../service-case/model/flatRateUnit';
import { ValueUpdater } from '../valueUpdater';
import { FlatRateUnitV10 } from './v10/case/model/flatRateUnitV10';
import { FlatRateUnitV11 } from './v11/service-case/model/flatRateUnitV11';
export class FlatRateUnitTransformer {
    static transformList(inVersion, outVersion, payload) {
        const resultList = [];
        payload.forEach((flatRateUnit) => {
            resultList.push(this.transform(inVersion, outVersion, flatRateUnit));
        });
        return resultList;
    }
    static transform(inVersion, outVersion, payload) {
        const transformation = inVersion + '-to-' + outVersion;
        switch (transformation) {
            case '12-to-10':
                return this.transformFromV12ToV10(payload);
            case '12-to-11':
                return FlatRateUnit.constructFromPlainObject(payload);
            case '10-to-12':
                return this.transformFromV10ToV12(payload);
            case '11-to-12':
                return FlatRateUnitV11.constructFromPlainObject(payload);
            default:
                throw new Error('Unsupported transformation: ' + transformation);
        }
    }
    static transformFromV12ToV10(payload) {
        const fru = FlatRateUnit.constructFromPlainObject(payload);
        const fruV10 = new FlatRateUnitV10(fru.getDescription(), fru.getNumber(), fru.getAmount(), fru.getOriginalAmount(), fru.getComment(), fru.getType(), fru.getUnit());
        fruV10.setPositionNumber(ValueUpdater.updateNonNullableNumberOrUnknown(fruV10.getPositionNumber(), fru.getPositionNumber()));
        fruV10.setSelected(ValueUpdater.updateNonNullableField(fruV10.isSelected(), fru.getIsSelected()));
        return fruV10;
    }
    static transformFromV10ToV12(payload) {
        const fruV10 = FlatRateUnitV10.constructFromPlainObject(payload);
        const fru = FlatRateUnit.constructFromPlainObject(payload);
        fru.setIsSelected(ValueUpdater.updateNonNullableField(fru.getIsSelected(), fruV10.isSelected()));
        return fru;
    }
}
//# sourceMappingURL=flatRateUnitTransformer.js.map